module.exports = __webpack_public_path__ + "static/media/514147_03big.28574c78.jpg";